export default {
    "{{DFE_RESOURCE_URL}}": window.dfeResourceUrl || ''
}